import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { app_base_url } from "../Utils/baseUrl";
import { Inicio } from "../Pages/Cartorio_Pages/App_Pages/Inicio";
import { Funcionarios } from "../Pages/Cartorio_Pages/App_Pages/Funcionarios";
import { Perfil } from "../Pages/Cartorio_Pages/App_Pages/Perfil";
import { Imoveis } from "../Pages/Cartorio_Pages/App_Pages/Imoveis";
import { Prefeituras } from "../Pages/Cartorio_Pages/App_Pages/Prefeituras";
import { Funcionario_Perfil } from "../Pages/Cartorio_Pages/App_Pages/Funcionario_Perfil";
import { OperacaoProvider } from "../Hooks/operacoes";
import { FuncionarioCartorioProvider } from "../Hooks/funcionarioCartorio";
import { Operacoes } from "../Pages/Cartorio_Pages/App_Pages/Operacoes";
import { ImovelFocus } from "../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { ComunicacaoProvider } from "../Hooks/comunicacoes";
import { ImovelProvider } from "../Hooks/imoveis";
import { ImoveisRurais } from "../Pages/Cartorio_Pages/App_Pages/ImoveisRurais";
import { ImovelFocusRural } from "../Pages/Cartorio_Pages/App_Pages/ImovelFocusRural";
import { TransmitenteProvider } from "../Storage/Transmitente";
import { AdquirinteProvider } from "../Storage/Adquirente";
import { SupportLogo } from "../Components/Suporte";
import { Pesquisar } from "../Pages/Cartorio_Pages/App_Pages/Pesquisar";

export function FuncionarioCartorioRoutes() {
  return (
    <Router>
      <SupportLogo />
      <ImovelProvider>
        <FuncionarioCartorioProvider>
          <TransmitenteProvider>
            <AdquirinteProvider>
              <ComunicacaoProvider>
                <OperacaoProvider>
                  <Routes>
                    <Route
                      path={`${app_base_url}/perfil`}
                      element={<Funcionario_Perfil />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/imoveis`}
                      element={<Imoveis />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/imoveis-rurais`}
                      element={<ImoveisRurais />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/operacoes`}
                      element={<Operacoes />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/prefeituras`}
                      element={<Prefeituras />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/Pesquisar`}
                      element={<Pesquisar />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/imovel/:id`}
                      element={<ImovelFocus />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/imovel-rural/:id`}
                      element={<ImovelFocusRural />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/redirecionamento/:destino`}
                      element={<Inicio />}
                    ></Route>
                    <Route
                      path={`${app_base_url}*`}
                      element={<Inicio />}
                    ></Route>
                  </Routes>
                </OperacaoProvider>
              </ComunicacaoProvider>{" "}
            </AdquirinteProvider>
          </TransmitenteProvider>{" "}
        </FuncionarioCartorioProvider>
      </ImovelProvider>
    </Router>
  );
}
